import styled from 'styled-components';

import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { mediaUp, rem } from 'approot/shared/style';

export const SimpleModalContentOuter = styled.div`
  ${baseFlexCss}
  border-top: 1px solid ${grey5};
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
`;

export const SimpleModalContentInner = styled.div`
  overflow: auto;
  overflow-x: hidden;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const SimpleModalContentInset = styled.div`
  padding: ${rem(spacing24)};
`;

export const SimpleModalActions = styled(Box).attrs({
  $alignItems: 'center',
  $justifyContent: 'space-between',
  $gap: 16,
})`
  border-top: 1px solid ${grey5};
  flex-direction: column;
  padding: ${rem(spacing24)};
  width: 100%;

  ${mediaUp.sm`
    flex-direction: row;
  `}
`;

export const SimpleModalCardItem = styled.li`
  width: 100%;

  ${mediaUp.sm`
    width: calc((100% - ${rem(spacing16 * 1)}) / 2);
  `}

  ${mediaUp.md`
    width: calc((100% - ${rem(spacing16 * 2)}) / 3);
  `}
`;
